export default {
  drawer: true,
  role: '',
  is_admin: false,
  is_teacher: false,
  is_editorLeader: false,
  is_editor: false,
}
